<template>
  <v-container
    fluid
    fill-height
    v-if="!progress">
    <v-row
      justify=center
      align=center
      v-for="(student, index) in this.students.get()"
      :key="student.getId()">
      <v-col
        cols=auto>
        <v-btn
          class="font-weight-bold"
          x-large
          color="primary"
          dark
          @click="toEditor(index)"
          >
          <span>エディタルームに<br>入室する</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VEditor from '@/components/organisms/editor/VEditor.vue'
import { StudentRepository } from '@/repository/StudentRepository.js'
import { firestore } from '@/repository/client/firestore.js'

export default {
  components: {
    "VEditor": VEditor
  },
  data() {
    return {
      teacher: this.$store.getters.teacher,
      students: null,
      progress: true
    }
  },
  methods: {
    toEditor(index) {
      this.$router.push('/teacher/' + this.teacher.uuid + '/editor/' + index)
    }
  },
  async created() {
    const studentRepo = new StudentRepository(firestore)
    this.students = await studentRepo.collect(this.teacher.studentIds)
    this.progress = false
  }
}
</script>